<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'App',
})
</script>
<!--
 * @Author: hubery huangbingcan@babybus.com
 * @Date: 2025-05-06 16:00:39
 * @LastEditors: Hubery Huang
 * @LastEditTime: 2025-12-18 17:31:35
 * @FilePath: /bugu-mall/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="app-wrapper" id="app">
    <router-view v-slot="{ Component, route }">
      <keep-alive :include="cachedComponents">
        <component :is="Component" :key="route.fullPath" />
      </keep-alive>
    </router-view>
    <modal ref="modalRef" />
    <message ref="messageRef" />
  </div>
</template>

<script setup name="App" lang="ts">
import { ref, computed, provide, onMounted } from "vue";
import Modal from "@/components/Modal/Modal.vue";
import Message from "@/components/Message/Message.vue";
import { useGlobalStore } from "@/stores/index";
import { usePageBase } from "@/composables/usePageBase";
import { useOnReachBottom } from "@/composables/useOnReachBottom";
import mitt from "mitt";

// 组件引用
const modalRef = ref(null);
const messageRef = ref(null);

// 使用 store
const globalStore = useGlobalStore();

// 使用 computed 包装 cachedComponents
const cachedComponents = computed(() => {
  console.log("缓存页面状态变化:", globalStore.keepAliveComponents || []);
  return globalStore.keepAliveComponents || [];
});

const eventBusService = mitt();

provide("$bus", eventBusService);

// 生命周期钩子
onMounted(() => {
  // 注册全局插件引用
  // window.vueIns = window.vueIns || {};
  // window.vueIns.$AppProtocol = AppProtocol;

  // 载入vue后关闭html的加载动画
  document.getElementById("prev-load").style.display = "none";
});
</script>

<style lang="less">
@import "./assets/css/reset.less";
@import "./App.less";
</style>
